import {createSelector} from 'reselect'
import {isJobPermissibleForRescheduling} from 'helpers/jobs'
import {RescheduleJobCandidatesType} from 'redux/jobs/state'
import {AppState} from 'redux/config'
import {FilterOptionType, Status} from 'commonTypes'

export const select_jobs = (state: AppState) => state.jobs.jobs
export const select_jobDetails = (state: AppState) => state.jobs.job
export const select_jobIdToCopy = (state: AppState) => state.jobs.jobIdToCopy
export const select_status = (state: AppState) => state.jobs.status
export const select_statusDetails = (state: AppState) => state.jobs.statusDetails
export const select_error = (state: AppState) => state.jobs.error

export const select_gridSession = (state: AppState) => state.jobs.gridSession
export const select_gridSession_pageCount = (state: AppState) => state.jobs.gridSession.pageCount
export const select_gridSession_resultsCount = (state: AppState) => state.jobs.gridSession.resultsCount
export const select_gridSession_pageSizeOptions = (state: AppState) => state.jobs.gridSession.pageSizeOptions
export const select_gridSession_sorting = (state: AppState) => state.jobs.gridSession.sorting

export const select_rescheduleJobs_permissible = (state: AppState) => state.jobs.rescheduleJobs.permissible
export const select_rescheduleJobs_selected = (state: AppState) => state.jobs.rescheduleJobs.selected

export const select_jobs_showFilters = (state: AppState) => state.jobs.showFilters
export const select_jobs_showDetails = (state: AppState) => state.jobs.showDetails

export const select_gridSession_filters = (state: AppState) => state.jobs.gridSession.filters
export const select_gridSession_filters_searchQuery = (state: AppState) => state.jobs.gridSession.filters.searchQuery
export const select_gridSession_filtersOptions = (state: AppState) => state.jobs.gridSession.filterOptions

export const select_status_isPending = createSelector(
  select_status,
  status => status === Status.PENDING
)

export const select_statusDetails_isPending = createSelector(
  select_statusDetails,
  status => status === Status.PENDING
)

export const select_gridSession_filters_areDirty = createSelector(
  select_gridSession_filters,
  filters => (
    filters.jobType.length !== 0 || filters.jobStatus.length !== 0 || filters.databaseId.length !== 0
  )
)

export const select_jobs_areThereJobsPermissibleForRescheduling = createSelector(
  select_rescheduleJobs_permissible,
  permissible => Object.keys(permissible).length > 0
)

export const select_jobs_permissibleForRescheduling = createSelector(
  select_jobs,
  jobs => jobs
    .reduce((permitted, job) => {
      if (isJobPermissibleForRescheduling(job.status)) {
        permitted[job.jobId] = true
      }
      return permitted
    },
    {} as RescheduleJobCandidatesType
    )
)

export const select_rescheduleJobs_allSelected = createSelector(
  select_rescheduleJobs_permissible,
  select_rescheduleJobs_selected,
  (permissible, selected) =>
    Object.keys(permissible).length > 0
    && Object.keys(selected).length === Object.keys(permissible).length
)

export const select_rescheduleJobs_noneSelected = createSelector(
  select_rescheduleJobs_selected,
  (selected) => Object.keys(selected).length === 0
)

export const select_rescheduleJobs_indeterminate = createSelector(
  select_rescheduleJobs_permissible,
  select_rescheduleJobs_selected,
  (permissible, selected) =>
    Object.keys(permissible).length > 0
    && Object.keys(selected).length > 0
    && Object.keys(selected).length < Object.keys(permissible).length
)

export const select_rescheduleJobs_selectedJobIds = createSelector(
  select_rescheduleJobs_selected,
  selected => Object.keys(selected)
)

export const select_gridSession_filtersOptions_raveUrl = createSelector(
  select_gridSession_filtersOptions,
  filtersOptions => filtersOptions.raveUrl
    .map(database => ({
      value: database.databaseId,
      label: database.hostname,
      subLabel: database.databaseId,
    } as FilterOptionType))
)

export const select_jobTypeActionOptionsStatus = (state: AppState) => state.jobs.jobTypeActionOptions.status

export const select_jobTypeActionOptionsError = (state: AppState) => state.jobs.jobTypeActionOptions.error

export const select_jobTypeActionOptions = (state: AppState) => state.jobs.jobTypeActionOptions.options
